import React from 'react';
import Navbar from "@/components/Navbar";
import MobileNav from "@/components/MobileNav";

export default function About() {
  return (
    <div className="min-h-screen bg-[#FFF6E5] pb-20 md:pb-0">
      <Navbar />
      
      <div className="container mx-auto px-4 max-w-4xl py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-[#E6D5BC] p-8 md:p-12">
          
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-[#9B111E] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>Our Story</h1>
            <div className="h-1 w-20 bg-[#D4AF37] mx-auto rounded-full"></div>
          </div>

          <div className="prose prose-lg max-w-none text-[#2A2A2A]">
            <p className="mb-6 leading-relaxed">
              Welcome to <strong>Ras Raj - The Mithai Shop</strong>, Amethi's premier destination for authentic, luxury Indian sweets. For decades, we have stood by a singular promise: absolute purity and uncompromised taste.
            </p>

            <h3 className="text-2xl font-bold text-[#9B111E] mt-8 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>The Brothers Behind the Brand</h3>
            <div className="flex flex-col md:flex-row gap-8 items-start mb-8">
              <div className="w-full md:w-1/3 bg-[#F5E6D3] h-64 rounded-xl border-2 border-[#D4AF37] flex items-center justify-center text-[#B8962E] font-bold">
                [Insert Brothers Image Here]
              </div>
              <div className="w-full md:w-2/3">
                <p className="leading-relaxed mb-4">
                  Ras Raj is powered by the dynamic synergy of two brothers. The digital innovation, modern branding, and creative direction are spearheaded by the 6'1", lean, and driven visionary of the duo. 
                </p>
                <p className="leading-relaxed">
                  Meanwhile, the robust daily operations and traditional quality control are anchored by his 6-foot, bearded brother, whose strong, welcoming presence ensures every box leaving the shop meets our golden standards. Together, they bridge the gap between timeless tradition and modern convenience.
                </p>
              </div>
            </div>

            <h3 className="text-2xl font-bold text-[#9B111E] mt-8 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>We Do Not Weight Box</h3>
            <p className="leading-relaxed">
              Our unique promise, <em>"Hum Dibba Nahi Taulte"</em>, is our commitment to fairness. When you pay for a kilogram of sweets, you receive a full kilogram of sweets. The weight of our premium packaging is always on us, ensuring you get exactly what you pay for.
            </p>
          </div>

        </div>
      </div>
      
      <MobileNav />
    </div>
  );
}